module.exports = __webpack_public_path__ + "media/img/pages/companies/lidl-a54dc1bb9f95cdc57c72ad073048c09e.webp";